import { render, staticRenderFns } from "./PartnerSiteTable.vue?vue&type=template&id=18387044&"
import script from "./PartnerSiteTable.vue?vue&type=script&lang=js&"
export * from "./PartnerSiteTable.vue?vue&type=script&lang=js&"
import style0 from "./PartnerSiteTable.vue?vue&type=style&index=0&id=18387044&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports